import { useState } from 'react'
import moment from 'moment'

export default function MonthPicker({ id = '', className = '', error = '', startDate, endDate, saveDate }) {
    const [startMonth, setStartMonth] = useState(moment(startDate).format('YYYY-MM'))
    const [endMonth, setEndMonth] = useState(moment(endDate).format('YYYY-MM'))

    const handleStartChange = e => {
        const newDate = e.target.value
        setStartMonth(newDate)
        updateDates(moment(newDate), moment(endMonth))
    }

    const handleEndChange = e => {
        const newDate = e.target.value
        setEndMonth(newDate)
        updateDates(moment(startMonth), moment(newDate))
    }

    const updateDates = (start, end) => {
        saveDate(start.startOf('month').format('YYYY-MM-DD'), end.endOf('month').format('YYYY-MM-DD'))
    }

    return (
        <div className={className}>
            <div className="flex gap-4">
                <div className="w-full">
                    {/* <label 
                        className={`block mb-2 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}
                    >
                        From Month
                    </label> */}
                    <input
                        type="month"
                        id={`${id}_start`}
                        value={startMonth}
                        onChange={handleStartChange}
                        className="w-full px-3 py-2 bg-transparent border rounded-lg outline-none border-stroke focus:border-primary dark:border-strokedark dark:bg-strokedark dark:focus:border-secondary"
                    />
                </div>
                <div className="w-full">
                    {/* <label 
                        className={`block mb-2 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}
                    >
                        To Month
                    </label> */}
                    <input
                        type="month"
                        id={`${id}_end`}
                        value={endMonth}
                        min={startMonth}
                        onChange={handleEndChange}
                        className="w-full px-3 py-2 bg-transparent border rounded-lg outline-none border-stroke focus:border-primary dark:border-strokedark dark:bg-strokedark dark:focus:border-secondary"
                    />
                </div>
            </div>
            {error && <p className="text-sm text-danger">{error}</p>}
        </div>
    )
}
